import type { CardHooks } from "./registry";

/**
 * Soulreaver — once per round, on heavy attack damage, gain a focus token.
 * Also: weapon always deals 1 damage even when fully blocked. The minimum-
 * damage rule lives in `resolveCombat` (playtestEngine.ts) — detected by
 * canonicalName so it triggers for the signature-move attack mode and the
 * equipment-weapon attack mode alike. This hook only covers focus generation.
 */
export const soulreaver: CardHooks = {
  onDamageDealt: (ctx) => {
    const { self, attackCard, damageDealt } = ctx;
    if (!damageDealt || damageDealt <= 0) return {};
    if (self.soulreaverUsedThisRound) return {};
    const isHeavy =
      attackCard?.attackDefendFields?.weight === "Heavy" ||
      attackCard?.equipmentFields?.attackWeight === "Heavy";
    if (!isHeavy) return {};
    return {
      selfPatch: { soulreaverUsedThisRound: true },
      focusGrant: 1,
      log: ["Soulreaver — +1 focus on heavy attack damage"],
    };
  },
  onRoundStart: () => ({
    selfPatch: { soulreaverUsedThisRound: false },
  }),
};
